import client from "../Client/HttpClient";
import {IHeadquartersModel} from "@/interfaces/modules";
const ApiPath = "Headquarters";

export default {
    GetHeadquarters:() : Promise <IHeadquartersModel[]> => client.get(`${ApiPath}`),
    GetHeadquartersbyId: (data: IHeadquartersModel): Promise <IHeadquartersModel> => client.get(`${ApiPath}/${data.Id}`), 
    PostHeadquarters: (data: IHeadquartersModel): Promise<IHeadquartersModel> => client.post(`${ApiPath}`, data)
  };